const s = {
  name: "CreditCardCheck",
  dimensions: { width: 40, height: 33 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 40 33" style="enable-background:new 0 0 40 33;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M5,21h12v-2H5V21z"/>
		<path class="st0" d="M27.5,27.4l3.7-3.7l-1.4-1.4l-2.3,2.3l-1.3-1.3l-1.4,1.4L27.5,27.4z"/>
		<path class="st0" d="M40,21c0,2.4-1.7,4.5-4.1,4.9c-0.5,4-3.8,7.1-7.9,7.1c-4.1,0-7.4-3.1-7.9-7H5c-2.8,0-5-2.2-5-5V5
			c0-2.8,2.2-5,5-5h30c2.8,0,5,2.2,5,5V21z M2,5h36c0-1.7-1.3-3-3-3H5C3.3,2,2,3.3,2,5z M2,7v3h36V7H2z M2,21c0,1.7,1.3,3,3,3h15.1
			c0.5-3.9,3.9-7,7.9-7c4,0,7.4,3,7.9,6.9c1.2-0.4,2.1-1.5,2.1-2.9v-9H2V21z M28,19c-3.3,0-6,2.7-6,6s2.7,6,6,6s6-2.7,6-6
			S31.3,19,28,19z"/>
	</g>
</g>
</svg>
  `
};
export {
  s as CreditCardCheck
};
